import { HGetKeyEnums } from "@rf-helper/generat-enums-from-keys";
import { object, string, boolean, InferType } from "yup";

export const ReportPropertySchema = object({
  id: string().required("ID es requerido"),
  reportImage: boolean().default(false),
  reportDescription: boolean().default(false),
  reportDocuments: boolean().default(false),
  propertyNotAvailable: boolean().default(false),
  reportLocation: boolean().default(false),
  comment: string().default("").meta({ label: "Comentario" })
});

export type IReportPropertySchema = InferType<typeof ReportPropertySchema>;
export const CReportProperty = ReportPropertySchema.getDefault();
export const CReportPropertyKeys = HGetKeyEnums(CReportProperty) as {
  [K in keyof typeof CReportProperty]: K;
};
